import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

Vue.filter('NumberFormat', function (value, round = false, len = 4) {
  if (!value) {
    return '0'
  }
  let decStr = ''
  value = value.toString().split('.')[0]
  
  if (round && value.length > len) {
    value = Number(value) / 10000
    if (value % 1 !== 0) { // value 不是整数
      const valueStrArr = value.toString().split('.')
      value = valueStrArr[0]
      const dec = valueStrArr[1].substr(0, 2)
      Number(dec) && (decStr = `.${dec}`)
    } 
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat + decStr
})

Vue.filter('dayjs', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('MoneyFormat', function(money) {
  if (money && money != null) {
    money = String(money)
    var left = money.split('.')[0], right = money.split('.')[1]
    right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00'
    var temp = left.split('').reverse().join('').match(/(\d{1,3})/g)
    return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right
  } else if (money === 0) { // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
    return '0.00'
  } else {
    return ''
  }
})